import { Controller } from "@hotwired/stimulus"

// Floating Action Button controller
// Handles opening/closing the FAB menu with animations
export default class extends Controller {
  static targets = ["menu", "button", "iconOpen", "iconClose"]

  connect() {
    this.isOpen = false
    // Close on escape key
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
    // Close on click outside
    this.boundClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.boundClickOutside)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
    document.removeEventListener("click", this.boundClickOutside)
  }

  toggle(event) {
    event.stopPropagation()
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.isOpen = true
    this.menuTarget.classList.remove("opacity-0", "invisible", "translate-y-4")
    this.menuTarget.classList.add("opacity-100", "visible", "translate-y-0")

    // Rotate icons
    this.iconOpenTarget.classList.add("opacity-0", "rotate-90", "scale-0")
    this.iconCloseTarget.classList.remove("opacity-0")
    this.iconCloseTarget.classList.add("rotate-0")

    // Add backdrop feel
    this.buttonTarget.classList.add("ring-4", "ring-brand-200", "dark:ring-brand-800")
  }

  close() {
    this.isOpen = false
    this.menuTarget.classList.add("opacity-0", "invisible", "translate-y-4")
    this.menuTarget.classList.remove("opacity-100", "visible", "translate-y-0")

    // Reset icons
    this.iconOpenTarget.classList.remove("opacity-0", "rotate-90", "scale-0")
    this.iconCloseTarget.classList.add("opacity-0")
    this.iconCloseTarget.classList.remove("rotate-0")

    // Remove backdrop feel
    this.buttonTarget.classList.remove("ring-4", "ring-brand-200", "dark:ring-brand-800")
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close()
    }
  }

  handleClickOutside(event) {
    if (this.isOpen && !this.element.contains(event.target)) {
      this.close()
    }
  }
}
